import { render, staticRenderFns } from "./devicePage.vue?vue&type=template&id=1ff345d0&"
import script from "./devicePage.vue?vue&type=script&lang=js&"
export * from "./devicePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports